import { isMarketingSitePath } from './marketingNavigation';

/**
 * Paths handled by React Router (client-side). Marketing pages (/, /about, …)
 * are served by peppar-site and must use full page navigation.
 */
export function isReactClientRoute(path: string): boolean {
  const pathname = (path || '').split('?')[0].split('#')[0] || '/';
  if (isMarketingSitePath(pathname)) {
    return false;
  }
  if (pathname.startsWith('/restaurants')) return true;
  const reactPaths = ['/signin', '/forgotPassword', '/resetPassword', '/partner/setup', '/partner/legal-accept', '/supplier', '/my-account', '/my-orders', '/saved-addresses'];
  return reactPaths.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}
